<template>
  <div class="skeleton-container">
    <div
      v-for="(line, index) in lines"
      :key="index"
      class="skeleton-line"
      :style="{
        width: getRandomWidth(index),
        height: height + 'px',
        borderRadius: borderRadius,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "TextSkeleton",
  props: {
    lines: {
      type: Number,
      default: 10,
    },
    height: {
      type: Number,
      default: 8,
    },
    borderRadius: {
      type: String,
      default: "6px",
    },
  },
  methods: {
    getRandomWidth(index) {
      // Create some variation for realism
      const widths = ["95%", "50%", "85%", "90%", "75%", "40%", "90%"];
      return widths[index % widths.length];
    },
  },
};
</script>

<style scoped>
.skeleton-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: transparent;
}

.skeleton-line {
  background: #cccccc ; /* Tailwind's gray-300 */
  animation: pulse 1.5s infinite ease-in-out;
}


@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
</style>
